import {
    REQUEST_PROTECTION_PLAN,
    RECEIVE_PROTECTION_PLAN,
    IProtectionPlanState,
    ProtectionPlanTypes,
    ICheckContractChangeState,
    IReceiveContractChange,
    RECEIVE_CONTRACT_CHANGE,
} from "./types";

const initialState: IProtectionPlanState = { protectionPlanData: { IsIDFUser: false }, isLoading: false };

export function protectionPlanReducer(state = initialState, action: ProtectionPlanTypes): IProtectionPlanState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case REQUEST_PROTECTION_PLAN:
            return {
                isLoading: true,
                protectionPlanData: state.protectionPlanData,
            };
        case RECEIVE_PROTECTION_PLAN:
            return {
                isLoading: false,
                protectionPlanData: action.protectionPlanData,
            };
        default:
            return state;
    }
}
const initialStateContract: ICheckContractChangeState = {
    checked: false,
    cancellatinoContinuationData: undefined,
    contractChangeData: undefined,
    fromRedirectUrl: false,
};
export function checkContractChangeReducer(state = initialStateContract, action: IReceiveContractChange): ICheckContractChangeState {
    if (state === undefined) {
        return initialStateContract;
    }

    switch (action.type) {
        case RECEIVE_CONTRACT_CHANGE:
            return {
                checked: true,
                contractChangeData: action.data.contractChangeData,
                cancellatinoContinuationData: action.data.cancellatinoContinuationData,
                fromRedirectUrl: action.data.fromRedirectUrl,
            };
        default:
            return state;
    }
}
